module.exports = __webpack_public_path__ + "img/headphones-in-ear.afbaed73.png";